export class ChatMessagePostBodyDto {
  senderId: string
  channelType: string
  txt: string
  attachments: string[]

  constructor(
    senderId: string,
    channelType: string,
    txt: string,
    attachments: string[]
  ) {
    this.senderId = senderId
    this.channelType = channelType
    this.txt = txt
    this.attachments = attachments
  }
}
